// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const filterSharedReportPathParamsSchema = z.object({
  uid: z.coerce.string().describe("Unique identifier of the shared report"),
});

export const filterSharedReportQueryParamsSchema = z.object({
  scope: z.optional(z.enum(["totals", "events"]).describe("Result scope: totals (aggregated data) or events (individual entries). Default: totals")),
  group_by: z.optional(z.coerce.string().describe("Comma-separated list of grouping keys: clients, users, labels, days. Only applicable for totals scope")),
}).optional();

/**
 * @description Shared report events retrieved successfully
 */
export const filterSharedReport200Schema = z.unknown();

/**
 * @description Shared report not found or events not enabled
 */
export const filterSharedReport404Schema = z.unknown();

export const filterSharedReportQueryResponseSchema = z.lazy(() => filterSharedReport200Schema);
